export const urlBase = "/MeditocCallCenter";
//export const urlBase = "/MeditocCallCenter";
//export const urlBase = "/PreProduccionCallCenter";
//export const urlBase = "/QAPreCallCenter";

export const urlSystem = {
    login: "/login",
    configuracion: {
        usuarios: "/usuarios",
        perfiles: "/perfiles",
        sistema: "/sistema",
    },
    administracion: {
        colaboradores: "/colaboradores",
        institucion: "/empresas",
        productos: "/productos",
        cupones: "/cupones",
        especialidades: "/especialidades",
        anuncios: "/anuncios",
        motivosconsulta: "/motivoconsulta",
    },
    folios: {
        folios: "/folios",
    },
    callcenter: {
        consultas: "/consultas",
        administrarConsultas: "/administrar",
        misconsultas: "/misconsultas",
    },
    reportes: {
        ordenes: "/orden",
        doctores: "/doctores",
    },
};

export const urlDefault = "/";
